import React from "react";
import { ClientLocal } from "app/api/types";
import _ from 'lodash';

import "./styles.scss";
import ChatFormInput from "./components/Input";
import ChatFormUser from "./components/User";
import ChatFormMessage from "./components/Message";
import ChatFormTelegram from "./components/Telegram";

interface IProps {
	clients: ClientLocal[],
	notifyTyping: (receiverId: number) => any;
	postMessage: (receiverId: number, message: string) => any;
	loadClientMessages: (clientId: number) => any,
	changeTelegram: (name: string) => any;
	telegram: string;
}

interface IState {
	clientId: number;
}

class ChatForm extends React.Component<IProps, IState> {
	state: IState = {
		clientId: -1,
	};
	body: HTMLDivElement | null = null;

	/** Выбран чат */
	get isSelected(): boolean {
		return this.state.clientId > -1;
	}

	/** Id выбранного клиента */
	get currentId(): number {
		return this.props.clients.find(x => x.companionId === this.state.clientId)?.companionId ?? 1;
	}

	/** Выбрать пользователя */
	setClientId(id: number) {
		this.props.loadClientMessages(id);
		this.setState({
			...this.state,
			clientId: id,
		});
	}

	/** Реф на поле сообщений */
	setBody(element: HTMLDivElement | null) {
		this.body = element;
		if (this.body) {
			this.body.scrollTop = this.body.scrollHeight;
		}
	}

	renderBackButton() {
		const phone = this.props.clients.find(x => this.state.clientId === x.companionId)?.companionPhone;
		return (<div className={'chat-form__top'}>
			<div className={'phrase-del'} onClick={() => this.setClientId(-1)}>Назад</div>
			{phone ? (<div>(т. {phone})</div>) : ''}
		</div>);
	}

	renderUsers() {
		if (this.props.clients.length < 1)
			return (<div>Пока у вас нет сообщений</div>);
		return (<ul>
			{
				_.sortBy(this.props.clients, 'companionId')
					.reverse()
					.filter(x => !!x.companionId)
					.map(x => (
						<li key={x.companionId} onClick={() => this.setClientId(x.companionId)}>
							<ChatFormUser
								key={x.companionId}
								clientInfo={x}
							/>
						</li>)
					)
			}
		</ul> )
	};

	renderTypingStatus() {
		if (!this.isSelected) return '';
		const client = this.props.clients.find(x => this.state.clientId === x.companionId);
		return (
			<div className={'chat-form__typing-status'}>
				{client?.isTyping ? `${client.companionName} набирает сообщение...` : ''}
			</div>
		);
	}

	renderMessages() {
		if (this.state.clientId < 0) return (<div>Выберите чат</div>)
		const client = this.props.clients.find(x => x.companionId === this.state.clientId);
		const messages = client?.messages ?? [];
		return (<div
					ref={el => this.setBody(el) }
					className={'chat-form__messages phrase-container'}
				>
				{messages
					.map((x, i) => (
						<ChatFormMessage
							name={client?.companionName ?? null}
							key={i}
							message={x}
						/>
					))
				}
				</div>);
	};

	render() {
		return (
			<div className="chat-form">
				{ !this.isSelected
					? <ChatFormTelegram
						telegramName={this.props.telegram}
						changeTelegram={name => this.props.changeTelegram(name)}
					/>
					: ''
				}
				{ this.isSelected ? this.renderBackButton() : ''}
				{ !this.isSelected
					? this.renderUsers()
					: this.renderMessages()
				}
				{ this.renderTypingStatus() }
				{ this.isSelected
					? <ChatFormInput
						receiverId={this.currentId}
						notifyTyping={(clientId: number) => this.props.notifyTyping(clientId)}
						postMessage={(clientId, text) => this.props.postMessage(clientId, text)}
					/>
					: ''
				}
			</div>);
	}
}

export default ChatForm;
